import React from "react";
import { useParams } from "react-router-dom";
import { Phone } from "lucide-react";
import { StatusBadge } from "@/components/kmt/ui";
import { StageStepper } from "@/components/dash/StageStepper";
import { AgreementPanel, CancelPanel, ConfirmPanel, HistoryPanel, InvoicePanel, PaymentsPanel, QuotePanel, TripPanel } from "@/components/dash/BookingPanels";
import { useLoad, useOwnerApi } from "@/lib/api";
import { prettyPhone } from "@/lib/format";
import { PageTitle } from "./DashLayout";

export default function BookingDetail() {
  const { id } = useParams();
  const api = useOwnerApi();
  const { data: b, error, reload } = useLoad(() => api.get(`/bookings/${id}`).then((r) => r.data), [api, id]);
  if (error) return <p className="text-red-200">{error}</p>;
  if (!b) return <p className="text-mist/70">Loading…</p>;
  const onChange = () => reload();
  const props = { b, api, onChange };
  return (
    <div className="flex flex-col gap-6" data-testid="booking-detail">
      <PageTitle title={b.name} sub={`${b.ref} · ${b.source === "web" ? "Website request" : "Phone booking"}`}>
        <div className="flex flex-wrap items-center gap-3">
          <a href={`tel:${b.phone}`} className="inline-flex min-h-[48px] items-center gap-2 rounded-full border border-gold/50 px-5 text-gold hover:bg-gold/10" data-testid="booking-call-link"><Phone size={18} /> {prettyPhone(b.phone)}</a>
          <StatusBadge status={b.status} label={b.status_label} />
        </div>
      </PageTitle>
      <div className="rounded-md border border-gold/20 bg-aubergine/50 p-5"><StageStepper status={b.status} /></div>
      <div className="grid items-start gap-6 2xl:grid-cols-[1.4fr_1fr]">
        <div className="flex min-w-0 flex-col gap-6">
          <TripPanel {...props} />
          <QuotePanel {...props} />
          <PaymentsPanel {...props} />
          <InvoicePanel {...props} />
        </div>
        <div className="flex min-w-0 flex-col gap-6">
          <ConfirmPanel {...props} />
          <AgreementPanel {...props} />
          <CancelPanel {...props} />
          <HistoryPanel b={b} />
        </div>
      </div>
    </div>
  );
}
